import Http from 'common/services/Http';
import { DuesListItemDto } from './models/DuesListDto';

class DueService {
    public getByIdUser(idUser: string) {
        return Http.get<DuesListItemDto[]>('dues/' + idUser);
    }
}

export default new DueService();